import {Component, OnInit} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {FirebaseStatusService} from '@app/firebase-status/firebase-status.service';
import {AsyncPipe, NgIf} from '@angular/common';
import {Router} from '@angular/router';
import {DoWorksService} from '@app/4dm1n/works-dashboard/do-works.service';
import {MatBadgeModule} from '@angular/material/badge';

@Component({
  selector: 'app-live-workers',
  templateUrl: './live-workers.component.html',
  imports: [
    MatButtonModule,
    NgIf,
    AsyncPipe,
    MatBadgeModule
  ],
  standalone: true,
  styleUrls: ['./live-workers.component.scss']
})
export class LiveWorkersComponent implements OnInit {

  constructor(
    public firebaseStatusService: FirebaseStatusService,
    private router: Router,
    public doWorksService: DoWorksService
  ) {
  }

  ngOnInit(): void {
  }

  gotoDashboard() {

    this.router.navigate(['4dm1n/workersDashboard']).then((data) => {
      return true;
    });

  }
}
